import { createFileRoute, useNavigate, Link } from "@tanstack/react-router";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const Route = createFileRoute("/coach-login")({
  head: () => ({ meta: [{ title: "Logga in som coach — Inkubera" }] }),
  component: CoachLogin,
});

function CoachLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    setBusy(false);
    if (error) return toast.error(error.message);
    navigate({ to: "/coach-portal" });
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4 py-12">
      <form onSubmit={handleSubmit} className="w-full max-w-md rounded-2xl border border-border bg-card p-8 space-y-5">
        <div>
          <div className="text-xs uppercase tracking-[0.18em] text-muted-foreground mb-2">Inkubera · Coach</div>
          <h1 className="font-display text-2xl">Logga in</h1>
          <p className="text-sm text-muted-foreground mt-2">
            Använd din e-postadress och det lösenord du satte vid aktivering.
          </p>
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="email">E-post</Label>
          <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="pw">Lösenord</Label>
          <Input id="pw" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </div>
        <Button type="submit" disabled={busy} className="w-full">
          {busy ? "Loggar in…" : "Logga in"}
        </Button>
        <div className="text-center">
          <Link to="/forgot-password" className="text-xs text-muted-foreground hover:text-foreground underline">
            Glömt lösenord?
          </Link>
        </div>
        <p className="text-xs text-muted-foreground text-center">
          Saknar du konto? Be Inkubera om en aktiveringslänk.
        </p>
        <p className="text-[11px] text-muted-foreground text-center">
          <Link to="/login" className="underline">Personalinloggning</Link>
        </p>
      </form>
    </div>
  );
}
